export default "__VITE_ASSET__edfa66bc__"